import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { AlertController, NavController, LoadingController, ToastController } from '@ionic/angular';

import { SalonPaymentTypes } from '../../../models';
import { SalonService } from '../../../services/salon.service';
import { UserService } from '../../../services/user.service';
import { Utilities } from '../../../utilities/utilities';
import { Router } from '@angular/router';
@Component({
  selector: 'app-payment-types',
  templateUrl: './payment-types.page.html',
  styleUrls: ['./payment-types.page.scss'],
})
export class PaymentTypesPage implements OnInit {


  public salonPaymentTypes: SalonPaymentTypes;

  public isLoading: boolean;

  public errorOccured: boolean;

  public cash: UntypedFormControl;

  public debit: UntypedFormControl;

  public visa: UntypedFormControl;

  public mastercard: UntypedFormControl;

  public amex: UntypedFormControl;

  public cheque: UntypedFormControl;

  public giftcard: UntypedFormControl;

  public etransfer: UntypedFormControl;

  public account: UntypedFormControl;

  public square: UntypedFormControl;

  public discover: UntypedFormControl;

  public paymentTypesForm: UntypedFormGroup;

  constructor (private navCtrl: NavController,
               private salonService: SalonService,
               private userService: UserService,
               private formBuilder: UntypedFormBuilder,
               private alertController: AlertController,
               private loadingCtrl: LoadingController,
               private toastController: ToastController,
               private ref: ChangeDetectorRef,
               private router: Router
  ) {
    this.cash = new UntypedFormControl();
    this.debit = new UntypedFormControl();
    this.visa = new UntypedFormControl();
    this.mastercard = new UntypedFormControl();
    this.amex = new UntypedFormControl();
    this.cheque = new UntypedFormControl();
    this.giftcard = new UntypedFormControl();
    this.etransfer = new UntypedFormControl();
    this.account = new UntypedFormControl();
    this.square = new UntypedFormControl();
    this.discover = new UntypedFormControl();
    this.paymentTypesForm = this.formBuilder.group({
      cash: this.cash,
      debit: this.debit,
      visa: this.visa,
      mastercard: this.mastercard,
      amex: this.amex,
      cheque: this.cheque,
      giftcard: this.giftcard,
      etransfer: this.etransfer,
      account: this.account,
      square: this.square,
      discover: this.discover
    });
  }

 
  public ngOnInit () {
    this.loadPaymentTypes();
  }

  public loadPaymentTypes () {
    this.isLoading = true;
    this.errorOccured = false;
    this.salonService.getSalonPaymentTypes()
      .subscribe({next: (paymentType: SalonPaymentTypes) => {
          this.salonPaymentTypes = paymentType;
          this.cash.setValue(this.salonPaymentTypes.cash === 1);
          this.debit.setValue(this.salonPaymentTypes.debit === 1);
          this.visa.setValue(this.salonPaymentTypes.visa === 1);
          this.mastercard.setValue(this.salonPaymentTypes.mastercard === 1);
          this.amex.setValue(this.salonPaymentTypes.amex === 1);
          this.cheque.setValue(this.salonPaymentTypes.cheque === 1);
          this.giftcard.setValue(this.salonPaymentTypes.giftcard === 1);
          this.etransfer.setValue(this.salonPaymentTypes.etransfer === 1);
          this.account.setValue(this.salonPaymentTypes.account === 1);
          this.square.setValue(this.salonPaymentTypes.square === 1);
          this.discover.setValue(this.salonPaymentTypes.discover === 1);
          this.isLoading = false;
          this.ref.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          this.errorOccured = true;
          this.ref.detectChanges();
        }});
  }

  public async save () {
    if (!this.paymentTypesForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({spinner: 'crescent'});
    loader.present();

    this.salonPaymentTypes = this.salonPaymentTypes.setCash(this.cash.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setDebit(this.debit.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setVisa(this.visa.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setMasterCard(this.mastercard.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setAMEX(this.amex.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setCheque(this.cheque.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setGiftcard(this.giftcard.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setEtransfer(this.etransfer.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setAccount(this.account.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setSquare(this.square.value ? 1 : 0);
    this.salonPaymentTypes = this.salonPaymentTypes.setDiscover(this.discover.value ? 1 : 0);

    this.salonService.savePaymentType(this.salonPaymentTypes)
      .subscribe((salonPaymentTypes) => {
          this.salonPaymentTypes = salonPaymentTypes;
          loader.dismiss().then(() => {
            this.router.navigateByUrl("/settings/pos-settings").then(async () => {
              const toast = await this.toastController.create({
                message: `Payment types have been updated`,
                duration: 3000
              })
              toast.present();
            });
          });
        },
        (err) => {
          loader.dismiss().then(async () => {
            const alert = await this.alertController.create(Utilities.getDefaultErrorMessageConfig())
            alert.present();
          });
        });
  }

}
